module.exports = __webpack_public_path__ + "img/ic_remove_shift.bf7cf3d2.svg";